import { render, staticRenderFns } from "./Reservations_list.vue?vue&type=template&id=2fe63bc2&scoped=true&"
import script from "./Reservations_list.vue?vue&type=script&lang=js&"
export * from "./Reservations_list.vue?vue&type=script&lang=js&"
import style0 from "./Reservations_list.vue?vue&type=style&index=0&id=2fe63bc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe63bc2",
  null
  
)

export default component.exports